export const energyAnalysisCacheKeys = {
  allScenarios: (projectId: string) => ["energy-analysis-all-scenarios", projectId],
};
